export default __webpack_public_path__ + "static/media/kitchen4-afterD-1440w.2f09c29f.webp";